import { ActivatedRouteSnapshot } from '@angular/router';

export const getUrlPath = (route: ActivatedRouteSnapshot): string => {
  return `/${route.url.map(url => url.path).join('/')}`;
};
